import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import vehicleSubjectChange, { PersonDTO, VehicleSubjectChangeAttachmentsSubmitDTO } from "serverApi/vehicleSubjectChange";
import { Attachment } from "types";

import { VehicleSubjectChangeFormValues } from "../types/VehicleSubjectChangeFormValues";

export default function useAttachments() {
    const { getValues } = useFormContext<VehicleSubjectChangeFormValues>();

    const [isAttachmentsFetching, setIsAttachmentsFetching] = useState(true);
    const [attachments, setAttachments] = useState<Attachment[]>([]);

    useEffect(() => {
        const getAttachments = async () => {
            const dto = getSubmitDto();
            const [error, res] = await vehicleSubjectChange.getAttachments(dto);

            if (error) {
                setIsAttachmentsFetching(false);
                return;
            }

            if (res.ok && res.body) {
                setAttachments(res.body);
            }

            setIsAttachmentsFetching(false);
        };

        getAttachments();
    }, []);

    function getSubmitDto() {
        const v = getValues();

        const owner: PersonDTO = v.editOwner
            ? {
                  subjectType: v.owner.legalEntity === 1 ? "INDIVIDUAL" : "COMPANY",
                  firstName: v.owner.person?.firstName,
                  lastName: v.owner.person?.lastName,
                  birthNumber: v.owner.person?.birthNumber,
                  phoneNumber: v.owner.person?.phone,
                  email: v.owner.person?.email,
                  companyIdentificationNumber: v.owner.organisation?.organisationId,
                  companyName: v.owner.organisation?.name,
                  address: {
                      street: v.owner.address.street,
                      orientationNumber: v.owner.address.orientationNo,
                      descriptionNumber: v.owner.address.descriptiveNo,
                      city: v.owner.address.city,
                      postalCode: v.owner.address.zipCode,
                      countryCode: v.owner.address.country,
                  },
              }
            : undefined;

        const operator: PersonDTO = v.editOperator
            ? {
                  subjectType: v.operator.legalEntity === 1 ? "INDIVIDUAL" : "COMPANY",
                  firstName: v.operator.person?.firstName,
                  lastName: v.operator.person?.lastName,
                  birthNumber: v.operator.person?.birthNumber,
                  phoneNumber: v.operator.person?.phone,
                  email: v.operator.person?.email,
                  companyIdentificationNumber: v.operator.organisation?.organisationId,
                  companyName: v.operator.organisation?.name,
                  address: {
                      street: v.operator.address.street,
                      orientationNumber: v.operator.address.orientationNo,
                      descriptionNumber: v.operator.address.descriptiveNo,
                      city: v.operator.address.city,
                      postalCode: v.operator.address.zipCode,
                      countryCode: v.operator.address.country,
                  },
              }
            : undefined;

        const dto: VehicleSubjectChangeAttachmentsSubmitDTO = {
            subjectChangeId: v.idChange,
            idObject: v.idObject,
            vinNumber: v.vinNumber,
            licencePlateNumber: v.licencePlateNumber,
            owner: owner,
            operator: operator,
        };

        return dto;
    }

    return {
        attachments,
        isAttachmentsFetching,
    };
}
